import { defaultMapper } from '@/common/service/default-mapper';
import {
  EVENT_SAAS_ADDITIONAL_CO_EDITOR,
  EVENT_SAAS_ADDITIONAL_HOST, EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR,
  EVENT_SAAS_CORE_ADDITIONAL_HOST,
  PlanModelInfo,
  planTypes, zoomOneEnterpriseCategory,
} from '@/common/constants';
import { pageConfig } from '@/common/service/page-config';
import { plansof } from '@/utils/chain';


export const ZOOM_SASS_ADD_ON_BASE_PLAN_MAP = {
  [EVENT_SAAS_ADDITIONAL_HOST]: planTypes.EVENT_SAAS,
  [EVENT_SAAS_ADDITIONAL_CO_EDITOR]: planTypes.EVENT_SAAS,
  [EVENT_SAAS_CORE_ADDITIONAL_HOST]: planTypes.EVENT_SAAS_CORE,
  [EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR]: planTypes.EVENT_SAAS_CORE,
};

export const AdditionalHostCategories = [
  EVENT_SAAS_ADDITIONAL_HOST, // zoom events additional host
  EVENT_SAAS_CORE_ADDITIONAL_HOST, // zoom sessions additional host
];

export const CATEGORY = AdditionalHostCategories.includes(pageConfig.editConfig.category)
  ? pageConfig.editConfig.category
  : {
      [planTypes.EVENT_SAAS]: EVENT_SAAS_ADDITIONAL_HOST,
      [planTypes.EVENT_SAAS_CORE]: EVENT_SAAS_CORE_ADDITIONAL_HOST,
    }[pageConfig.editConfig.planType];

export const Title = {
  [EVENT_SAAS_ADDITIONAL_HOST]: 'billing.events.addon.ze_hub_hosts_title',
  [EVENT_SAAS_CORE_ADDITIONAL_HOST]: 'billing.events.addon.zs_hub_hosts_title',
}[CATEGORY];

/**
 * @param {array} categories [EVENT_SAAS_ADDITIONAL_HOST, EVENT_SAAS_CORE_ADDITIONAL_HOST] | [EVENT_SAAS_ADDITIONAL_CO_EDITOR, EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR]
 * @param {string} category EVENT_SAAS_ADDITIONAL_HOST | EVENT_SAAS_CORE_ADDITIONAL_HOST | EVENT_SAAS_ADDITIONAL_CO_EDITOR | EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR
 * @param {string} planType planTypes.ADDITIONAL_HOST | planTypes.ADDITIONAL_CO_EDITOR
 * @param {string} typeNameKey
 */
export const handlePreData = (categories, category, planType, typeNameKey, planNameKey) => {
  return (planMapJSON, _, subscription) => {
    return categories.reduce((pre, key) => {
        return [
          ...defaultMapper(planMapJSON[key], planType).map((item) => {
            const dependBasePlanTypeList = [];
            const baseType = ZOOM_SASS_ADD_ON_BASE_PLAN_MAP[item.category];
            // if don't has zoom workplace ent plus plan
            if (plansof(subscription).category(zoomOneEnterpriseCategory.ent_plus).has()) {
              dependBasePlanTypeList.push(planTypes.ZOOM_ONE);
            } else {
              dependBasePlanTypeList.push(baseType);
            }
            return {
              ...item,
              productInfo: { max: 20, min: 1 },
              baseType,
              typeNameKey,
              planNameKey,
              isCurrentCategory: category === item.category,
              dependBasePlanTypeList,
              billingCycleDependBasePlanTypeList: dependBasePlanTypeList,
              planModel: PlanModelInfo.license
            };
          }),
          ...pre,
        ];
      }, []);
  };
};

export default handlePreData(
  AdditionalHostCategories,
  CATEGORY,
  planTypes.ADDITIONAL_HOST,
  'billing.planform.title.additional_host',
  Title,
);
